import { Box, EmptyView, Loader } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useCallback, useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
import { Container } from '../../../comps/Container'
import { useLazyApiData, useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'
import { getErrorMessage } from '../../../util/utill'
import { SearchBar } from './SearchBar'
import { TransactionListItem } from './TransactionListItem'

export const DMRTransactionsScreen = () => {
  const navigation: any = useNavigation()
  const [remmiterMobileNo, setRemitterMobileNo] = useState('')
  const [showCloseIcon, setShowCloseIcon] = useState(false)

  const { getDmrTransactionsAsync } = useStores((root) => ({
    getDmrTransactionsAsync: root.transactionDetails.getDmrTransactionsAsync,
  }))

  const [lazyFetchTransactionHistoryApi, fetchTransactionHistoryApiHandler] = useLazyApiData(getDmrTransactionsAsync)

  const [_dataProvider, setDataProvider] = useState(
    new DataProvider((r1, r2) => {
      return r1 !== r2
    }),
  )

  console.log('fetchTransactionHistoryApiHandler', fetchTransactionHistoryApiHandler?.data)

  useEffect(() => {
    if (fetchTransactionHistoryApiHandler.state === 'fulfilled') {
      setDataProvider(
        new DataProvider((r1, r2) => {
          return r1 !== r2
        }).cloneWithRows(fetchTransactionHistoryApiHandler.data),
      )
    }
  }, [fetchTransactionHistoryApiHandler.data, fetchTransactionHistoryApiHandler.state])

  useEffect(() => {
    lazyFetchTransactionHistoryApi(remmiterMobileNo)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [layoutProvider] = useState(
    new LayoutProvider(
      (_) => {
        return 'LIST_ITEM'
      },
      (_, dim) => {
        dim.width = Math.round(Dimensions.get('window').width)
        dim.height = 130
      },
    ),
  )

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Transactions' })
  }, [navigation])

  const onItemPress = (data: any) => {
    navigation.navigate(
      Screens.TRANSACTION_SUCCESS_SCREEN as never,
      {
        type: 'transaction_detail',
        idempotentKey: data?.idempotentKey,
      } as never,
    )
  }

  const onSearchClick = useCallback(
    (iconType) => {
      console.log('htag onSearchClick', iconType)
      if (iconType === 'SEARCH') {
        setRemitterMobileNo(remmiterMobileNo)
        lazyFetchTransactionHistoryApi(remmiterMobileNo)
        setShowCloseIcon(true)
      } else if (iconType === 'CLOSE') {
        setRemitterMobileNo('')
        setShowCloseIcon(false)
        console.log('htag in')
        lazyFetchTransactionHistoryApi('')
      }
    },
    [lazyFetchTransactionHistoryApi, remmiterMobileNo],
  )

  const rowRenderer = (_: any, data: any) => {
    return <TransactionListItem data={data} onPress={onItemPress} />
  }

  return (
    <Container showFooter={true} paddingHorizontal={0}>
      <SearchBar
        text={remmiterMobileNo}
        onSearchClick={onSearchClick}
        iconType={
          fetchTransactionHistoryApiHandler.state === 'pending' ? 'LOADING' : showCloseIcon ? 'CLOSE' : 'SEARCH'
        }
        onChange={setRemitterMobileNo}
      />
      <Container
        backgroundColor={'WHITE'}
        paddingHorizontal={0}
        paddingTop={0}
        paddingBottom={0}
        isLoading={fetchTransactionHistoryApiHandler.state === 'pending'}>
        <>
          {_dataProvider.getSize() === 0 && (
            <Box f={1} justify="center" alignItems={'center'}>
              <EmptyView
                onRetry={() => lazyFetchTransactionHistoryApi(remmiterMobileNo)}
                isLoading={fetchTransactionHistoryApiHandler.state === 'pending'}
                loaderComponent={<Loader type="large" color="PRIMARY_STORNG" />}
                error={
                  getErrorMessage(fetchTransactionHistoryApiHandler) && {
                    networkError: {
                      data: { errors: [{ details: getErrorMessage(fetchTransactionHistoryApiHandler) }] },
                    },
                  }
                }
                emptyMessage={fetchTransactionHistoryApiHandler.state === 'fulfilled' ? 'No transactions Found' : ''}
              />
            </Box>
          )}
          {_dataProvider.getSize() > 0 && (
            <RecyclerListView rowRenderer={rowRenderer} dataProvider={_dataProvider} layoutProvider={layoutProvider} />
          )}
        </>
      </Container>
    </Container>
  )
}
